import { apiClient, ApiClientConfig } from "api";
import { CompanyType } from "types";
import { AllBookingStatsResponse } from "types/allbookingstats";
import { DayViewStatsResponse } from "types/dayviewstats";

export type GetDayViewStatsParams = {
  date?: any;
  company_id?: any;
  facility_id?: any;
  field_id?: any;
};

export type GetReportDTO = {
  data: {
    from_date: string;
    to_date: string;
  };
  params?: {
    company_type?: CompanyType;
    company_id?: string;
  };
};

export const ReportApiService = () => {
  const getConsolidatedReport = async (payload: GetReportDTO) => {
    const { data, params } = payload;
    const response = await apiClient({
      endpoint: "/admin/reports/consolidated",
      method: "POST",
      data,
      params,
      config: {
        responseType: "blob",
      },
    });

    return response;
  };
  const getCancelReport = async (payload: GetReportDTO) => {
    const { data, params } = payload;
    const response = await apiClient({
      endpoint: "/admin/Reports/cancelledbookings",
      method: "POST",
      data,
      params,
      config: {
        responseType: "blob",
      },
    });

    return response;
  };
  const getCustmizeAccountReport = async (payload: GetReportDTO) => {
    const { data, params } = payload;
    const response = await apiClient({
      endpoint: "/admin/Reports/customizeaccounts",
      method: "POST",
      data,
      params,
      config: {
        responseType: "blob",
      },
    });

    return response;
  };

  const getAccountsReport = async (payload: GetReportDTO) => {
    const { data, params } = payload;

    const response = await apiClient({
      endpoint: "/admin/reports/accounts",
      method: "POST",
      data,
      params,
      config: {
        responseType: "blob",
      },
    });

    return response;
  };
  const getClosingReport = async (payload: any) => {
    const baseURL = process.env.REACT_APP_BASE_V2_URL;
    const { data, params } = payload;
    const response = await apiClient({
      endpoint: `${baseURL}/exportrevenuereport`,
      method: "GET",
      data,
      params,
      config: {
        responseType: "blob",
      },
    });

    return response;
  };
  const getDayViewStats = async (
    params: GetDayViewStatsParams,
    callConfig?: Partial<ApiClientConfig>
  ) => {
    const response = await apiClient<DayViewStatsResponse>({
      ...callConfig,
      endpoint: `/admin/reports/dayviewstats`,
      params,
    });

    return response.data;
  };
  const getAllBookingStats = async (
    params: GetDayViewStatsParams,
    callConfig?: Partial<ApiClientConfig>
  ) => {
    const response = await apiClient<AllBookingStatsResponse>({
      ...callConfig,
      endpoint: `/admin/reports/bookingstats`,
      params,
    });

    return response.data;
  };
  const getdropdownlistFlag = async (
    params: GetDayViewStatsParams,
    callConfig?: Partial<ApiClientConfig>
  ) => {
    const baseURL = process.env.REACT_APP_BASE_V2_URL;
    const response = await apiClient<AllBookingStatsResponse>({
      ...callConfig,
      endpoint: `${baseURL}/dropdownlist`,
      params,
    });

    return response.data;
  };
  const getSalesReport = async (payload: GetReportDTO) => {
    const { data, params } = payload;

    const response = await apiClient({
      endpoint: "/admin/reports/sales",
      method: "POST",
      data,
      params,
      config: {
        responseType: "blob",
      },
    });

    return response;
  };
  const getPackagReport = async (payload: GetReportDTO) => {
    const { data, params } = payload;
    // /sports/api/v1/admin/Reports/

    // https://itplapiv2.li3ib.com/sports/api/v1/admin/reports/sales
    const response = await apiClient({
      endpoint: "/admin/Reports/package",
      method: "POST",
      data,
      params,
      config: {
        responseType: "blob",
      },
    });

    return response;
  };
  const getWalletReport = async (payload: GetReportDTO) => {
    const { data, params } = payload;
    // /sports/api/v1/admin/Reports/

    // https://itplapiv2.li3ib.com/sports/api/v1/admin/reports/sales
    const response = await apiClient({
      endpoint: "/admin/Reports/wallet",
      method: "POST",
      data,
      params,
      config: {
        responseType: "blob",
      },
    });

    return response;
  };
  const getCustomerReport = async (payload: GetReportDTO) => {
    const { data, params } = payload;
    // /sports/api/v1/admin/Reports/

    // https://itplapiv2.li3ib.com/sports/api/v1/admin/reports/sales
    const response = await apiClient({
      endpoint: "/admin/Reports/customerwallet",
      method: "POST",
      data,
      params,
      config: {
        responseType: "blob",
      },
    });

    return response;
  };

  return {
    getConsolidatedReport,
    getAccountsReport,
    getSalesReport,
    getDayViewStats,
    getAllBookingStats,
    getCancelReport,
    getCustmizeAccountReport,
    getPackagReport,
    getWalletReport,
    getCustomerReport,
    getClosingReport,
    getdropdownlistFlag,
  };
};
